import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import AddDossiersToFleetModal from '../../../../components/management/fleets/auxModals/AddDossiersToFleetModal'
import { closeAddDossiersToFleetModal, fetchDossiersToAddToFleet, fetchDossiersToAddToFleetSuccess, resetDossiersToAddToFleetSearch, fetchAddDossierToFleet } from '../../../../actions/management/auxModals/auxModals'
import { getDossierDetailsFleet } from '../../../../actions/management/management'
import TrackingContainer from '../../../tracking/trackingContainer'

export function mapStateToProps (state) {
  return {
    ...state.managementAuxModals.addDossiersToFleetModal,
    combos: {
      salesmanCombo: state.combos.salesmanCombo
    }
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      closeAddDossiersToFleetModal,
      fetchDossiersToAddToFleet,
      fetchDossiersToAddToFleetSuccess,
      resetDossiersToAddToFleetSearch,
      fetchAddDossierToFleet,
      getDossierDetailsFleet
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(TrackingContainer(AddDossiersToFleetModal, true)))
